import { useLazyQuery } from '@apollo/client/react';

import { WorkspaceDocument } from './wait-for-workspace.graphql';

const retryPromise = async <T>(fn: () => Promise<T>, retries = 10): Promise<T> => {
  try {
    return await fn();
  } catch (error) {
    if (retries <= 0) {
      throw error;
    }
    await new Promise((resolve) => setTimeout(resolve, 500));
    return retryPromise(fn, retries - 1);
  }
};

export const useWaitForWorkspace = (): {
  waitForWorkspace: (id: string) => Promise<void>;
} => {
  const [getWorkspace] = useLazyQuery(WorkspaceDocument);

  const waitForWorkspace = async (id: string) => {
    await retryPromise(() => getWorkspace({ variables: { workspaceId: id } }));
  };

  return { waitForWorkspace };
};
